<a *ngIf="subCategory.description" class="category-menu__item" [ngClass]="{'is-current': this.isActive()}"
   [attr.aria-selected]="isActive" (click)="select()">
  <span class="category-menu__title">{{subCategory.description}}</span>
  <span *ngIf="subCategory.invalid" matTooltip="{{'invalidFieldValue' | cbsLabel}}"><i class="fas fa-exclamation-triangle"></i></span>
</a>
